import React from 'react';

import Layout from '../../../components/layout';

const SettingsNotifications = () => {
  const headerData = {
    title: 'Оповещения'
  };

  return (
    <Layout
      headerData={headerData}
    >
      <div className="content">
      Оповещения
      </div>
    </Layout>
  );
};

export default SettingsNotifications;
